import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('navigation', {
      campaignId: (state) => state.campaignId,
      allCampaigns: (state) => state.allCampaigns,
    }),

    campaign: {
      get() {
        return this.campaignId;
      },
      set(value) {
        if (value) {
          this.navigationShowAllCampaigns(false);
        }
        this.navigationSetCampaign(value);
      },
    },
  },

  methods: {
    ...mapActions('navigation', {
      navigationShowAllCampaigns: 'showAllCampaigns',
      navigationSetCampaign: 'setCampaign',
    }),
  },
};
